// extracted by mini-css-extract-plugin
export default {"container":"Testimonial_container__TVlfc","singleCard":"Testimonial_singleCard__J6sTC"};